import React from 'react';

import Button, { ButtonGroup, LoadingButton } from '@atlaskit/button';
import TextArea from '@atlaskit/textarea';

import { trackEvent } from 'src/lib/analytics';
import jira from 'src/lib/api/jira';
import pd from 'src/lib/api/pagerduty';

import ErrorMessage from 'src/views/components/ErrorMessage';
import Field from 'src/views/components/Form/Field';
import ModalContainer from 'src/views/components/ModalContainer';

const analyticsEventName = 'sidebar_incidentresponse_add_note';
class AddNoteForm extends React.Component {
  state = { inProcessing: false, note: '', error: null }

  closeModal = () => {
    trackEvent(analyticsEventName, { label: 'cancel' });
    jira.closeCurrentModal();
  }

  addNote = () => {
    this.setState({ inProcessing: true });
    const { incidentId } = this.props;
    const { note } = this.state;
    trackEvent(analyticsEventName, { label: 'add_note' });
    pd.addNote(incidentId, note)
      .then(() => {
        this.closeModal();
      })
      .catch(error => {
        this.setState({ inProcessing: false, error: ['Failed to add note', error] });
      });
  };

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
    this.addNote();
  };

  render() {
    const { inProcessing, note, error } = this.state;
    const isEmpty = !note.length;

    return (
      <div>
        <form onSubmit={this.onSubmit}>
          <Field label="Note:">
            <TextArea
              minimumRows={5}
              placeholder="Please add your note here"
              value={note}
              onChange={e => this.setState({ note: e.target.value })}
            />
          </Field>

          {!inProcessing && error && <div style={{ marginTop: 24 }}>
            <ErrorMessage error={error}/>
          </div>}

          <div style={{ paddingTop: 24, paddingBottom: 24, display: 'flex', justifyContent: 'flex-end' }}>
            <ButtonGroup>
              <Button onClick={this.closeModal}>Cancel</Button>
              <LoadingButton type="submit" appearance="primary" isLoading={inProcessing} isDisabled={isEmpty}>Add note</LoadingButton>
            </ButtonGroup>
          </div>
        </form>
      </div>
    );
  }
}

const ModalAddNote = () => {
  const incidentId = new URLSearchParams(window.location.search).get('incidentId');

  return (
    <ModalContainer title={'Add note'}>
      <AddNoteForm incidentId={incidentId}/>
    </ModalContainer>
  );
};

export default ModalAddNote;
